import React from "react";
import "./RefundPolicy.css";

const RefundPolicy = () => {
  return (
    <div className="refund-policy-container">
      <h1>Refund Policy</h1>
      <p><strong>Effective Date:</strong> [Insert Date]</p>
      <p><strong>Business Name:</strong> Indvo - Gateway of Indian Market</p>
      <p><strong>Contact Email:</strong> Contact@indvo.com</p>
      <p><strong>Services Covered:</strong> Indian Market Expansion Services & Sourcing Agent Services</p>

      <h2>1. Our Commitment to Satisfaction</h2>
      <p>
        At Global Expansion Gateway, we are committed to client success and transparency. While most of our services involve operational setup and third-party engagement, we understand that business needs can change. That’s why we offer a flexible refund policy with both partial and full refund options, depending on timing and service usage.
      </p>

      <h2>2. Full Refunds – Within 24 Hours of Payment</h2>
      <p>
        If you decide to cancel within 24 hours of making a payment, we will issue a full refund minus any payment processing fees, such as:
      </p>
      <ul>
        <li>PayPal fees</li>
        <li>Razorpay charges</li>
        <li>Bank transfer costs</li>
      </ul>
      <p>This applies to all plans and service types, as long as no major work has started.</p>

      <h2>3. Partial Refunds – After 24 Hours</h2>
      <p>If you cancel after 24 hours, we will:</p>
      <ul>
        <li>Review all internal work logs</li>
        <li>Calculate the time and resources spent (including third-party coordination, strategy creation, communication, research, or logistics setup)</li>
        <li>Deduct the calculated expense</li>
        <li>Refund the remaining balance</li>
      </ul>
      <p>This applies to all active services, including Expansion Plans and Sourcing Projects.</p>

      <h2>4. Refund Eligibility by Service</h2>
      <p><strong>✅ Indian Market Expansion Plans (Standard & Enterprise)</strong></p>
      <ul>
        <li>Partial refunds available if cancellation occurs after 24 hours but before 15 days of service</li>
        <li>No refunds after 15 days unless service delivery failure is verified</li>
        <li>Ongoing subscriptions must be canceled in writing before next billing cycle</li>
      </ul>

      <p><strong>✅ Sourcing Agent Services</strong></p>
      <ul>
        <li>Full refund (minus fees) available within 24 hours</li>
        <li>Partial refund available if sourcing has not reached the supplier outreach or sampling phase</li>
        <li>No refund once supplier negotiations or sample dispatch begins</li>
      </ul>

      <h2>5. Non-Refundable Items</h2>
      <ul>
        <li>Services fully rendered</li>
        <li>Government fees, customs charges, or taxes already paid</li>
        <li>Expenses incurred with third-party vendors (unless refundable by them)</li>
      </ul>

      <h2>6. How to Request a Refund</h2>
      <p>Please email <strong>Contact@indvo.com</strong> with:</p>
      <ul>
        <li>Your full name and business name</li>
        <li>Service purchased</li>
        <li>Reason for the refund</li>
        <li>Proof of payment (invoice or transaction ID)</li>
      </ul>
      <p>Refund requests will be reviewed and responded to within 5–7 business days.</p>

      <h2>7. Chargebacks</h2>
      <ul>
        <li>All services will be paused immediately</li>
        <li>We may contest the dispute and submit supporting documentation</li>
        <li>The client may be blacklisted from future service eligibility</li>
      </ul>

      <h2>8. Changes to This Policy</h2>
      <p>We may update this policy based on legal or operational changes. Revisions will be posted on this page with a new "Effective Date."</p>

      <h2>9. Contact Us</h2>
      <p>📧 Email: Contact@indvo.com</p>
      <p>🌐 Website: www.indvo.com</p>
    </div>
  );
};

export default RefundPolicy;
